import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
    multiselectInput: {
        paddingTop: `${theme.spacing(4)} !important`,
        paddingBottom: theme.spacing(1)
    },
    popupIndicator: {
        visibility: 'hidden'
    },
    listbox: {
        ...theme.typography.body2,
        fontWeight: 600
    }
}));
